/* @flow */
import * as React from 'react';

import { WIDTH, HEIGHT } from './constant';

type Props = {
  scale: number,
  avatar: ?string,
};

const W_H_RATE = 222 / 2 / 228;

export function Uriko(props: Props) {
  let { scale, avatar } = props;

  const style = React.useMemo(() => {
    let top = HEIGHT * (0.7 - 0.32) * scale;
    let left = 0.186 * WIDTH * scale;
    let height = HEIGHT * 0.32 * scale;
    let width = height * W_H_RATE;
    return {
      position: 'absolute',
      top,
      left,
      width,
      height,
    };
  }, [scale]);

  return <div className={`uriko uriko-${avatar || '1'}`} style={style} />;
}
